import ProLeadGenReport from './ProLeadGenReport';

export default ProLeadGenReport;
